import React from 'react';
import Input from 'pages/Dashboard/components/Input';
import {
  DEFAULT_EMPTY_VALUE,
} from 'core/constants';

type Props = {
  id: string;
  label: string;
  value?: string | null;
  className?: string;
};

export default function ConsentField({
  id,
  label,
  value,
  className,
}: Props) {
  return (
    <Input
      id={id}
      label={label}
      value={value ?? DEFAULT_EMPTY_VALUE}
      nonEditable
      className={className}
      readOnlyValueClassName="text-xs font-medium leading-none text-gray-600"
      labelClasses="text-xs text-gray-500 font-semibold leading-4"
      classes={{
        root: '!space-y-0',
        container: '!h-8 !min-h-8 !px-3 !py-0 bg-gray-50',
        label: '!font-medium',
      }}
    />
  );
}
